import { useContext } from "react";
import { LocaleContext } from "../../contexts/locale/locale";
import classes from "./company.module.css";

export const Company = () => {
	const { texts } = useContext(LocaleContext);

	return (
		<section className={classes.company} id="company">
			<div className={classes.left}>
				<div className={classes.content}>
					<h3 className={classes.title}>{texts.company.title}</h3>
					{texts.company.description.map((description, index) => (
						<p className={classes.description} key={index}>
							{description}
						</p>
					))}
				</div>
			</div>
			<div className={classes.right}>
				<img
					className={classes.image}
					src="/images/company.png"
					alt={texts.company.title}
				/>
			</div>
		</section>
	);
};
